import * as React from 'react';
import { Box, Skeleton } from '@mui/material';

type Props = {
    /** 骨架卡片数量，默认 3 */
    count?: number;
};

/**
 * 预约餐期列表加载占位：与真实餐期卡片布局一致，供接口较慢时展示。
 */
export function ReserveMealPeriodCardsSkeleton({ count = 3 }: Props) {
    return (
        <>
            {Array.from({ length: count }).map((_, skeletonIndex) => (
                <ReserveMealPeriodCardSkeleton key={`reserve-period-skeleton-${skeletonIndex}`} />
            ))}
        </>
    );
}

function ReserveMealPeriodCardSkeleton() {
    return (
        <Box className='reserve-period-card reserve-meal-period-page__period-skeleton'>
            <Box className='reserve-period-card__name-row'>
                <Skeleton variant='rounded' height={40} sx={{ flex: '1 1 280px', maxWidth: 360, minWidth: 200 }} />
                <Skeleton variant='rounded' width={120} height={40} />
            </Box>
            <Skeleton variant='text' width='40%' height={28} />
            <Box className='reserve-period-card__chips-row'>
                <Skeleton variant='rounded' width={160} height={40} sx={{ borderRadius: '24px' }} />
                <Skeleton variant='rounded' width={160} height={40} sx={{ borderRadius: '24px' }} />
                <Skeleton variant='rounded' width={140} height={40} sx={{ borderRadius: '24px' }} />
            </Box>
            <Box className='reserve-period-card__picker-row'>
                <Skeleton variant='rounded' width={200} height={40} />
                <Skeleton variant='circular' width={40} height={40} />
            </Box>
        </Box>
    );
}
